const trips = require("../trips");

const isProduction = process.env.GATSBY_DEPLOY_ENV === "production";

const privateTripPaths = Object.values(trips)
  .filter((trip) => !trip.available || trip.hideLink)
  .map((trip) => `/${trip.slug}`);

const robotsOptions = (() => {
  if (!isProduction) {
    return {
      host: "",
      sitemap: "",
      policy: [{ userAgent: "*", disallow: "/" }],
    };
  }
  return {
    host: "https://www.lovesonggetaway.com",
    sitemap: "https://www.lovesonggetaway.com/sitemap.xml",
    policy: [
      {
        userAgent: "*",
        allow: "/",
        ...(privateTripPaths.length ? { disallow: privateTripPaths } : null),
      },
    ],
  };
})();

module.exports = [
  "gatsby-plugin-react-helmet",
  {
    resolve: "gatsby-plugin-nprogress",
    options: {
      color: "#15bfdd",
      minimum: 0.5,
      showSpinner: false,
    },
  },
  {
    resolve: "gatsby-plugin-google-analytics",
    options: {
      trackingId: "UA-9161693-5",
      anonymize: true,
      head: true,
    },
  },
  {
    resolve: "gatsby-plugin-facebook-pixel",
    options: {
      pixelId: "650731655011350",
    },
  },
  {
    resolve: "gatsby-plugin-robots-txt",
    options: robotsOptions,
  },
  "gatsby-plugin-postcss",
  "gatsby-plugin-netlify", // make sure to put last
];



// WEBPACK FOOTER //
// ./lib/config/plugins.js